/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2RhcnlsYmVyZ2Vyb24vRG9jdW1lbnRzL3dlYnN0dWZmL2FuZ3VsYXIvZmlyZW5vdGVzL3NyYy9hcHAvbm90ZXMtbGlzdC9ub3Rlcy1saXN0LmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vVXNlcnMvZGFyeWxiZXJnZXJvbi9Eb2N1bWVudHMvd2Vic3R1ZmYvYW5ndWxhci9maXJlbm90ZXMvc3JjL2FwcC9ub3Rlcy1saXN0L25vdGVzLWxpc3QuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/notes-list/notes-list.component.css.shim.ngstyle.ts